/** Read ordered selections and legacy single prompt IDs without changing their order. */
export function senderGroupIds(raw: unknown, legacy?: string | null): string[] {
  return Array.isArray(raw)
    ? [...new Set(raw.filter((v): v is string => typeof v === "string" && v.trim().length > 0))]
    : legacy ? [legacy] : [];
}
